module.exports = __webpack_public_path__ + "img/H000090_fishhead.e21632be.png";